import { useAtomValue } from "jotai/react";

import { useOnboarding } from "@/context/OnboardingContext";
import { OnboardingStepEnum } from "@/domain/onboarding";
import { useOnboardingEntryPointData } from "@/hooks/useOnboardingEntryPointData";
import { onboardingShortCodeDataAtom } from "@/stores/atoms";
import { OnboardingTextType } from "@/utils/onboarding";

// The benefits step's copy for the current entry point and variant,
// independent of how a layout presents it.
export const useOnboardingBenefitsContent = () => {
  const onboardingShortCodeData = useAtomValue(onboardingShortCodeDataAtom);
  const { getI18nKey } = useOnboarding();

  const { i18nKeyContext } = useOnboardingEntryPointData(
    OnboardingStepEnum.BENEFITS,
  );

  const clinicName = onboardingShortCodeData?.clinicName;

  const title: OnboardingTextType = clinicName
    ? { i18nKey: getI18nKey("benefits.title"), i18nOptions: { clinicName } }
    : { i18nKey: getI18nKey("benefits.titleNoClinic") };

  return {
    title,
    description: {
      i18nKey: getI18nKey("benefits.description"),
    } satisfies OnboardingTextType,
    firstItem: {
      i18nKey: getI18nKey("benefits.firstItem"),
      i18nOptions: { context: i18nKeyContext },
    } satisfies OnboardingTextType,
    freeToUse: {
      i18nKey: getI18nKey("benefits.freeToUse"),
    } satisfies OnboardingTextType,
    infoIsPrivate: {
      i18nKey: getI18nKey("benefits.infoIsPrivate"),
    } satisfies OnboardingTextType,
  };
};
